module.exports = __webpack_public_path__ + "img/-.d4443c9e.svg";